<template>
	<div class="LeaseInformation">
		<div class="LeaseInformation_input">
			<div class="LeaseInformation_input_left">姓名</div>
			<div class="LeaseInformation_input_right">
				<input v-model="name" type="type" name="" id="" value="" placeholder="请输入姓名" />
			</div>
		</div>
		<div class="LeaseInformation_input">
			<div class="LeaseInformation_input_left">身份证号</div>
			<div class="LeaseInformation_input_right">
				<input maxlength="18" v-model="IdNumber" type="type" name="" id="" value="" placeholder="请输入身份证号" />
			</div>
		</div>
		<div class="LeaseInformation_input">
			<div class="LeaseInformation_input_left">设备租赁个数</div>
			<div class="LeaseInformation_input_right">
				<input type="number" name="" id="" value="" v-model="leasenum" placeholder="请输入设备租赁个数" />
			</div>
		</div>
		<div class="buttom_bc" @click="Preservation">
			确认
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<div @click="determine">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'LeaseInformation',
		data() {
			return {
				success: false,
				success_img: false,
				success_text: "",
				baseUrl: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true,
				leasenum: "请输入设备租赁个数",
				name_reg: "",
				IdNumber_reg: "",
				name: "",
				IdNumber: "",
				access_token: "",
				goodsid: ""
			}
		},
		methods: {
			getFocus() {    
				$("input").on("blur", function() {        
					window.scroll(0, 0);    
				});
			},
			determine() {
				var that = this;
				if(that.success_text == "租赁成功") {
					that.$router.go(-1)
				} else {
					that.success = false;
				}
			},
			validIdCard(value) {
				var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //加权因子 
				var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2]; //校验码 
				if (/^\d{17}\d|x$/i.test(value)) {
					var sum = 0,
						idx;
					for (var i = 0; i < value.length - 1; i++) {
						// 对前17位数字与权值乘积求和 
						sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
					}
					// 计算模（固定算法） 
					idx = sum % 11;
					// 检验第18为是否与校验码相等 
					return arrValid[idx] == value.substr(17, 1).toUpperCase();
				} else {
					return false;
				}
			},
			Preservation() {
				var that = this;
				that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
				that.IdNumber_reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
				if(that.name == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入姓名';
				} else if(!that.name_reg.test(that.name)) {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入正确的姓名';
				} else if(that.IdNumber == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入身份证号';
				} else if(!that.validIdCard(that.IdNumber)) {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入正确的18位身份证号（不包含特殊字符、汉字）';
				} else if(that.leasenum == '请输入设备租赁个数') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入设备租赁个数';
				} else {
					if(that.leasenum<1){
						that.success = true;
						that.success_img = false;
						that.success_text = '请输入正确的设备租赁个数';
					}else{
						wclient.view.showLoading();
					wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
					wclient.ajax({
						type: "GET",
						url: that.baseUrl + '?ugi=leasegoods&action=leaseinggoods',
						dataType: "json",
						async: true,
						data: {
							access_token: that.access_token,
							goodsid: that.goodsid,
							leasenum: that.leasenum,
							reamname: that.name,
							idcard: that.IdNumber,
							sumdeposit: '0'
						},
						success: function(data) {
							wclient.view.hideLoading();
							if(data.code == 'A00006') {
								that.success = true;
								that.success_img = true;
								that.success_text = '租赁成功';
							} else {
								that.success = true;
								that.success_img = false;
								that.success_text = data.errmsg;
							}

						}
					});
					}
					
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			that.access_token = localStorage.getItem('access_token');
			that.goodsid = sessionStorage.getItem('goodsid');
			if(publicUrl == "localhost") {
				
				var baseUrl = "https://operation.xs.weapi.org/reception/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://operation.xs.weapi.org/reception/ajax";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
			}
			that.baseUrl = baseUrl;
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
		}
	}
</script>

<style scoped>
	.LeaseInformation {
		width: 100%;
		height: 100vh;
		overflow: hidden;
		margin: 0 auto;
		-webkit-overflow-scrolling: touch;
		background: white;
	}
	
	.buttom_bc {
		width: 60%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 39px;
		border-radius: 48px;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: center;
		justify-content: center;
		color: #fff;
		font-size: 16px;
		margin: 0 auto;
		position: fixed;
		left: 50%;
		bottom: 2%;
		margin-left: -30%;
	}
	
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #B1B1B1;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #B1B1B1;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #B1B1B1;
	}
	
	input::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #B1B1B1;
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 23%;
		margin-left: 39%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 80%;
		color: black;
		font-size: 17px;
		font-weight: 600;
		text-align: center;
		margin: 20px auto 0;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.LeaseInformation_input {
		width: 90%;
		border-bottom: 1px solid #DBDBDB;
		padding: 0 5%;
		display: flex;
		justify-content: space-between;
		line-height: 60px;
		font-size: 14px;
	}
	
	input {
		border: none;
		outline: none;
		text-align: right;
		font-size: 14px;
	}
	
	select {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		outline: none;
		font-size: 15px;
		color: #B1B1B1;
		background: white !important;
		direction: rtl;
	}
	select option {
		direction: ltr;
	}
</style>


// WEBPACK FOOTER //
// src/components/LeaseInformation.vue